/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { applySnapshot, getSnapshot, types } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';

const GraphCodeModel = types
  .model('GraphCodeModel', {
    code: types.maybeNull(types.string),
    error: types.maybeNull(types.string)
  })
  .views((self) => ({
    get graphCode() {
      return self.code;
    },
    get hasError() {
      return !!self.error;
    }
  }))
  .actions((self) => ({
    // Fetch graph code
    getGraphCode(payload) {
      applySnapshot(self, {
        ...getSnapshot(self),
        code: null,
        error: null
      });
      Framework.getEventManager().publish(constants.GET_GRAPH_CODE, { payload });
    },

    // Set graph code response
    setGraphCode(data) {
      applySnapshot(self, {
        ...getSnapshot(self),
        code: data?.code || null
      });
      Framework.getEventManager().publish(constants.GET_GRAPH_CODE_SUCCESS, { code: data?.code });
    },

    // Set error
    setError(errorMessage) {
      applySnapshot(self, {
        ...getSnapshot(self),
        error: errorMessage
      });
      Framework.getEventManager().publish(constants.GET_GRAPH_CODE_ERROR, { error: errorMessage });
    },

    // Reset state
    resetState() {
      applySnapshot(self, {
        ...getSnapshot(self),
        code: null,
        error: null
      });
    }
  }));

export default GraphCodeModel;
